<template>
  <div>
    <!-- 券汇总列表 -->
    <baseBreadcrumb :page="$t('message.couponSummaryList')" :menu="$t('message.moneyManagement')"></baseBreadcrumb>
    <div class="body">
      <div class="table">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">

          <el-tab-pane label="已申请优惠券" name="1"></el-tab-pane>
        </el-tabs>
      </div>

      <!--已申请优惠券  -->
      <div>
        <div class="search">
          <!-- 开始日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" class="Container"
              type="date" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
          <!--  结束日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
              type="date" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div> <!-- 客户ID-->
          <div class="item">
            <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" class="Container"
              onfocus="this.select()" />
          </div> <!--  搜索 -->
          <el-button type="primary" @click="handleClick">
            {{ $t("message.search") }}
          </el-button>
          <!-- 免手续发放 -->
          <el-button type="primary" class="service" @click="grant">
            {{ $t("message.noProceduresRequiredForDistribution") }}
          </el-button>
        </div>
        <!-- 次数 -->
        <div class="frequency">
          本月剩余可用次数：<span>{{ usable_count }}</span>

        </div>
        <!-- 列表 -->
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!--  客户信息-->
            <li>
              {{ $t('message.userInfo') }}
            </li>
            <!--申请时间信息 -->
            <li>
              {{ $t('message.applicationTimeInformation') }}
            </li>
            <!--  申请原因-->
            <li>
              {{ $t('message.reasonForApplication') }}
            </li>
            <!--  券信息-->
            <li>
              {{ $t('message.couponInformation') }}
            </li>
            <!--  有效日期-->
            <li>
              {{ $t('message.effectiveDate') }}
            </li>
            <!--  类别-->
            <li>
              {{ $t('message.type') }}
            </li>
            <!--  额度/可用次数/折扣比例-->
            <li>
              {{ $t('message.limitnumberOfAvailableTimesdiscountRatio') }}/天
            </li>
            <!--  使用限制-->
            <li>
              {{ $t('message.useRestrictions') }}
            </li>
            <!--  状态-->
            <li>
              {{ $t('message.status') }}
            </li>
            <!--  使用信息-->
            <li>
              {{ $t('message.usageInformation') }}
            </li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li class="flex05">{{ item.rowNumber }}</li>

            <!--  客户信息-->
            <li>
              <div class="template">
                <p>ID:{{ item.user_id }}</p>
                {{ item.user_realname }}
              </div>
            </li>
            <!--申请时间信息 -->
            <li>
              <div class="template">
                <p>申请人:{{ item.apply_realname }}</p>
                申请时间:
                <p>{{ item.created_at }}</p>
              </div>
            </li>
            <!--  申请原因-->
            <li>
              {{ item.apply_reason }}
            </li>
            <!--  券信息-->
            <li>
              <div class="template">
                {{ item.name_chinese }}
                <p>NO:{{ item.sn }}</p>
              </div>
            </li>
            <!--  有效日期-->
            <li>
              <div class="template">
                <p>开始:</p>
                <p>{{ item.effective_date }}</p>
                <p>结束:</p>
                <p>{{ item.expiry_date }}</p>
              </div>
            </li>
            <!--  类别-->
            <li>
              <span :style="{ color: item.type == 1 ? '#2C96E7' : '#B4272D' }">
                {{ item.type_name }}</span>
            </li>
            <!--  额度/可用次数/折扣比例-->
            <li>
              <div class="template">
                <span :style="{ color: item.type == 1 ? '#2C96E7' : '#B4272D' }" v-if="item.type != '3'">
                  {{ item.discounts_amount_jpy }}
                </span>
                <span v-else>
                  <!-- {{ item }} -->
                  {{
                    item.discounts_amount_jpy &&
                      item.discounts_amount_jpy != "0"
                      ? item.discounts_amount_jpy
                      : item.discounts_rate + "%"
                  }}</span>

              </div>
            </li>
            <!--  使用限制-->
            <li>
              <div v-if="item.type <= 3">
                <span v-if="item.type != '3'">订单金额 >={{ item.min_consumption_jpy }}</span>
                <div v-else>
                  <p>订单金额 >={{ item.min_consumption_jpy }}</p>
                  <p>计费重量 >={{ item.min_weight }}</p>
                </div>
              </div>
              <div v-else>
                无
              </div>
            </li>
            <!--  状态-->
            <li>
              {{ item.status_name }}
            </li>
            <!--  使用信息-->
            <li>
              <div class="template">
                <p v-if="item.use_datetime">使用时间:</p>
                <p>{{ item.use_datetime }}</p>
                <p v-if="item.use_order_sn || item.use_porder_sn">单号:</p>
                <p>{{ item.use_order_sn }}{{ item.use_porder_sn }}</p>
                <!-- <p>{{ item.initial_amount }}</p> -->
                <!-- {{ item.initial_amount }} -->
              </div>
            </li>
          </ul>
        </div>
        <!-- 分页 -->
        <div class="paginationContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="datas.page" :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 生成券  -->
    <el-dialog :title="$t('message.generateCoupons')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="488px" center>
      <div class="content">
        <el-form :model="discountData" :rules="rules" ref="discountData" label-width="100px" class="demo-ruleForm"
          style="padding: 0 25px;">
          <el-form-item label="客户ID:" prop="userId">
            <el-input v-model="discountData.userId" v-if="!isConfirm"></el-input>
            <span v-else>{{ discountData.userId }}</span>
            <span style="margin-left: 20px;" v-if="isConfirm"> {{ $t('message.userName') }}： {{
              discountData.user_realname
            }}</span>

          </el-form-item>
          <el-form-item label="申请原因:" prop="apply_reason">
            <el-input v-model="discountData.apply_reason" type="textarea" v-if="!isConfirm"></el-input>
            <span v-else>{{ discountData.apply_reason }}</span>
          </el-form-item>
        </el-form>
        <p class="attentionItems" v-if="isConfirm">请核对客户ID是否正确，优惠券发放后，无法取消回退，请仔细核查信息！</p>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!isConfirm">
        <!-- 保存 -->
        <el-button type="primary" @click="secondaryConfirmation">{{
          $t("message.ok")
        }}</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-else>
        <!-- 取消 -->
        <el-button @click="isConfirm = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 立即发放 -->
        <el-button type="primary" @click="departStoreDiscount">{{
          $t("message.distributeImmediately")
        }}</el-button>
      </span>

    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: '1',
      datas: {
        dateEnd: '',
        dateStart: '',
        user_id: this.$route.query.userID,
        pageSize: 10,
        page: 1
      },
      total: 0,
      tableData: [],
      usable_count: 0,
      //生成卷
      discountData: {
        userId: '',
        apply_reason: '',
        user_realname: '',
      },
      dialogVisible: false,
      isConfirm: false,
      rules: {
        userId: [
          { required: true, message: '请输入客户ID', trigger: 'blur' },
        ],
        apply_reason: [
          { required: true, message: '请输入申请原因', trigger: 'blur' },
        ],
      }
    };
  },

  created() {
    this.discountHistory()
    this.departUsableCount()
  },
  methods: {
    getClientFreeByHistoryList() {
      this.$api.clienteleApi.getClientFreeByHistoryList(this.datas).then((res) => {
        this.tableData = res.data.list.data
        this.total = res.data.list.total
        this.usable_count = res.data.usable_count
      })
    },
    discountHistory() {
      this.$api.clienteleApi.discountHistory(this.datas).then((res) => {
        this.tableData = res.data.data
        this.total = res.data.total

      })
    },
    handleClick() {
      this.datas.page = 1
      if (this.activeName == 0) {
        this.getClientFreeByHistoryList()
      } else {
        this.discountHistory()
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      if (this.activeName == 0) {
        this.getClientFreeByHistoryList()
      } else {
        this.discountHistory()
      }
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      if (this.activeName == 0) {
        this.getClientFreeByHistoryList()
      } else {
        this.discountHistory()
      }
    },
    //部长可用次数查询
    departUsableCount() {
      this.$api.clienteleApi.departUsableCount(this.datas).then((res) => {
        this.usable_count = res.data

      })
    },
    // 免手续费发放
    grant() {
      if (this.usable_count == 0) return this.$message.error('这个月免手续发放次数为0')
      this.isConfirm = false
      this.discountData = {
        userId: '',
        apply_reason: '',
      }
      this.dialogVisible = true
    },
    // 二次确认
    secondaryConfirmation() {
      this.$refs.discountData.validate((valid) => {
        if (valid) {
          this.isConfirm = true
          this.$api.clienteleApi.clientList({ id: this.discountData.userId }).then((res) => {
            if (res.data.data != false) {
              this.discountData.user_realname = res.data.data[0].realname
              this.$forceUpdate()
            }

          });
        }
      })
    },

    // 立即发放
    departStoreDiscount() {
      this.$api.clienteleApi.departStoreDiscount(this.discountData).then((res) => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.isConfirm = false
        this.discountData = {
          userId: '',
          apply_reason: '',
        }
        this.discountHistory()
        this.departUsableCount()
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  position: relative;

  .service {
    position: absolute;
    top: 0;
    right: 0
  }

  .item {
    margin-right: 20px;
  }
}

.frequency {
  margin: 20px 0 50px;
  font-size: 30px;

  span {
    color: #B4272D;
    margin-right: 20px;
  }

  i {
    cursor: pointer;
  }
}

.table {
  margin: 20px 0;

  ol {
    height: 50px;
    text-align: center;
  }

  .flex05 {
    flex: 0.5;
  }
}

/deep/ .el-textarea__inner {
  min-height: 100px !important;
}

.attentionItems {
  color: #B4272D;
  font-size: 16px;
  font-weight: 600;
  padding: 10px 25px;
}
</style>